module.exports = __webpack_public_path__ + "025d6716ba42edc16ebbfd1b0c571709.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ball-beach.png
// module id = 2812
// module chunks = 0